import { normalizeOLBMoneyField } from "../../../utils/renderField";

export const formatOlbStyleAuthAmountValueFromBackend = (value) => {
  if (!value) return "";

  const valueToFixed = parseFloat(value).toFixed(2);

  const stringValue = `${valueToFixed}`;

  const formatted = normalizeOLBMoneyField(stringValue);

  return formatted;
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/misc/auth-amount-utility.js